import { createStyles } from '@mantine/emotion';

export const useStyles = createStyles((theme) => ({
  title: {
    height: '100%',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
    margin: 0,
    padding: 0
  },
  content: {
    height: '100%',
    width: '100%',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    flexDirection: 'column',
    marginLeft: theme.spacing.sm
  },
  ldapLabel: {
    bottom: -10,
    right: -10,
    position: 'absolute',
    backgroundColor: 'rgba(51, 154, 240, 1)',
    color: '#EFF8FF',
    padding: '3px 4px',
    borderRadius: '16px',
    fontWeight: '500',
    fontSize: '10px',
    lineHeight: '100%',
    letterSpacing: '0%',
    flexShrink: 0
  }
}));
